// extracted by mini-css-extract-plugin
export var body = "_hg-0";
export var sectionHeader = "_hg-4";
export var shortcutColumns = "_hg-2";
export var shortcutList = "_hg-1";
export var shortcutSection = "_hg-3";